import React, {useEffect} from 'react'

import {ImageProvider} from '@daedalus/core/src/staticContent/types/ImageProvider'

import {Modal} from '../Modal'
import {ImageCarouselWithThumbnail} from './ImageCarouselWithThumbnail'

interface Props {
  images: string[]
  selectedImage?: string
  isVisible: boolean
  isLoading?: boolean
  offerContent?: React.ReactNode
  hotelDetailsContent?: React.ReactNode
  onClose: () => void
  imageProvider: ImageProvider
  onVisible?: () => void
  trackLightboxGalleryThumbnail?: () => void
  onLightboxGalleryCarouselSwipe?: () => void
}
export const LightboxGalleryDesktop: React.FC<Props> = ({
  images,
  isLoading,
  isVisible,
  selectedImage,
  offerContent,
  hotelDetailsContent,
  onClose,
  onVisible,
  imageProvider,
  trackLightboxGalleryThumbnail,
  onLightboxGalleryCarouselSwipe
}) => {
  useEffect(() => {
    if (isVisible) {
      onVisible?.()
    }
  }, [onVisible, isVisible])

  return (
    <Modal isOpen={isVisible} onClose={onClose} dataTestId="gallery-overlay">
      <ImageCarouselWithThumbnail
        images={images}
        isLoading={isLoading}
        selectedImage={selectedImage}
        offerContent={offerContent}
        hotelDetailsContent={hotelDetailsContent}
        imageProvider={imageProvider}
        trackLightboxGalleryThumbnail={trackLightboxGalleryThumbnail}
        onLightboxGalleryCarouselSwipe={onLightboxGalleryCarouselSwipe}
      />
    </Modal>
  )
}
